import { render, staticRenderFns } from "./detailsBox.vue?vue&type=template&id=5d96192a&"
import script from "./detailsBox.vue?vue&type=script&lang=js&"
export * from "./detailsBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports